export class AgeParser {
  public static fromIso(yyyymmdd?: string | null, today = new Date()): string {
    if (!yyyymmdd) return ''

    const dateParts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(yyyymmdd)
    if (!dateParts) return ''

    const year = Number(dateParts[1])
    const month = Number(dateParts[2]) - 1
    const day = Number(dateParts[3])
    const birthDate = new Date(year, month, day)

    if (
      birthDate.getFullYear() !== year ||
      birthDate.getMonth() !== month ||
      birthDate.getDate() !== day
    ) {
      return ''
    }

    let age = today.getFullYear() - birthDate.getFullYear()
    const hasHadBirthdayThisYear =
      today.getMonth() > birthDate.getMonth() ||
      (
        today.getMonth() === birthDate.getMonth() &&
        today.getDate() >= birthDate.getDate()
      )

    if (!hasHadBirthdayThisYear) age -= 1

    return age >= 0 ? age.toString() : ''
  }
}
